import { useQueryClient } from "@tanstack/react-query";

import { showToast } from "@/components/ui";
import { useAttributeReviewMapRowValuesMutation } from "@/graphql/generated";

export function useMapRowValues() {
  const queryClient = useQueryClient();
  const mutation = useAttributeReviewMapRowValuesMutation({
    onSuccess: ({ attributeReviewMapRowValues: changed }) => {
      void queryClient.invalidateQueries({
        queryKey: ["AttributeReviewFieldMappings"],
        refetchType: "all",
      });
      if (changed) {
        showToast.success(
          "Values mapped",
          `${changed} values have a suggestion now.`,
        );
      } else {
        showToast.info("No new suggestions", "The AI gave the same answers.");
      }
    },
    onError: (err) => {
      showToast.error(
        "Could not map the values",
        err instanceof Error ? err.message : "Try again.",
      );
    },
  });

  const mapValues = (
    sessionId: string,
    sourceFieldId: string,
    path: string | null,
  ) => {
    if (!mutation.isPending)
      mutation.mutate({ sessionId, sourceFieldId, path });
  };

  return { mapValues, isMapping: mutation.isPending };
}
